module.exports = __webpack_public_path__ + "static/img/advert_2_2.ac0cc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/advert_2_2.png
// module id = 3CPo
// module chunks = 10